export enum SEGMENT_ADMIN {
    /**
     * @value Archived segments are no longer usable. If the segment is already in use, there will not be any impact.<br /><br />Segments can be subsequently unarchived.
     * @description Description of the modal displayed when a user tries to archive a segment
     */
    ARCHIVE_CONFIRMATION_DESCRIPTION = 'SEGMENT.ARCHIVE_CONFIRMATION_DESCRIPTION',
    /**
     * @value Archive segment?
     * @description Title of the modal displayed when archiving a segment
     */
    ARCHIVE_CONFIRMATION_TITLE = 'SEGMENT.ARCHIVE_CONFIRMATION_TITLE',
    /**
     * @value Available for
     */
    AVAILABLE_FOR = 'SEGMENT.AVAILABLE_FOR',
    /**
     * @value Available in analytics
     */
    AVAILABLE_IN_ANALYTICS = 'SEGMENT.AVAILABLE_IN_ANALYTICS',
    /**
     * @value Available in content
     */
    AVAILABLE_IN_CONTENT = 'SEGMENT.IS_GROUP_FILTER_CHECKED',
    /**
     * @value Broadcasts only
     */
    BROADCAST_ONLY = 'SEGMENT_ADMIN.BROADCAST_ONLY',
    /**
     * @value This segment can only be used to target Broadcasts
     */
    BROADCAST_ONLY_HELPER = 'SEGMENT_ADMIN.BROADCAST_ONLY_HELPER',
    /**
     * @value All rules and title must be filled
     * @description Tooltips displayed on hoover while the create segment button is disabled due to missing segment title and/or at least one segment rule remains empty
     */
    CREATE_TOOLTIPS = 'SEGMENT.HEADER_TOOLTIPS_CREATE_BUTTON',
    /**
     * @value Creating a duplicate might make it harder to manage your segments later.
     */
    DUPLICATE_SEGMENT_CONFIRM_MESSAGE = 'SEGMENT.DUPLICATE_SEGMENT_CONFIRM_MESSAGE',
    /**
     * @value Duplicate segment detected
     */
    DUPLICATE_SEGMENT_DETECTED = 'SEGMENT.DUPLICATE_SEGMENT_DETECTED',
    /**
     * @value At least one condition is needed
     */
    EMPTY_EXPORT = 'SEGMENT.EMPTY_EXPORT',
    /**
     * @value Export as CSV
     * @description Tooltips displayed when hoovering the export as csv button in segment list
     */
    EXPORT_CSV_TOOLTIPS = 'SEGMENT.EXPORT_CSV_TOOLTIPS',
    /**
     * @value Generating the file...
     */
    EXPORT_FILE_GENERATION = 'SEGMENT.EXPORT_FILE_GENERATION',
    /**
     * @value Export segment as CSV
     */
    EXPORT_TITLE = 'SEGMENT.EXPORT_TITLE',
    /**
     * @value Governance
     */
    GOVERNANCE = 'SEGMENT_ADMIN.GOVERNANCE',
    /**
     * @value Segment provisioning takes up to 24 hours when used in multiple features.
     */
    INFO_USAGE = 'SEGMENT.SEGMENT_PROPERTY_PROMOTION_WARNING',
    /**
     * @value Display only segments that are available in content (in the 'visible by' and 'highlighted for' fields).
     */
    IS_GROUP_FILTER = 'SEGMENT.IS_GROUP_FILTER',
    /**
     * @value There are no segments
     */
    NO_SEGMENTS = 'SEGMENT.NO_SEGMENTS',
    /**
     * @value Segments help you create list of users based on several criteria.
     */
    NO_SEGMENTS_DESCRIPTION = 'SEGMENT.NO_SEGMENTS_DESCRIPTION',
    /**
     * @value Platform-wide
     */
    PLATFORM_WIDE = 'SEGMENT_ADMIN.PLATFORM_WIDE',
    /**
     * @value Usable across all sites. Any update will impact every site using it.
     */
    PLATFORM_WIDE_HELPER = 'SEGMENT_ADMIN.PLATFORM_WIDE_HELPER',
    /**
     * @value A segment with the same name and rules already exists:
     */
    SAME_NAME_AND_RULE_ALREADY_EXISTS = 'SEGMENT.SAME_NAME_AND_RULE_ALREADY_EXISTS',
    /**
     * @value A segment with the same %CONFLICT_TYPE% already exists:
     */
    SAME_NAME_OR_RULE_ALREADY_EXISTS = 'SEGMENT.SAME_NAME_OR_RULE_ALREADY_EXISTS',
    /**
     * @value Segments
     */
    SEGMENT_SIDE_NAV_TITLE = 'SEGMENT.SIDE_NAV_TITLE',
    /**
     * @value This site only
     */
    SITE_ONLY = 'SEGMENT_ADMIN.SITE_ONLY',
    /**
     * @value Visible and usable only within this site.
     */
    SITE_ONLY_HELPER = 'SEGMENT_ADMIN.SITE_ONLY_HELPER',
    /**
     * @value Size unknown
     */
    SIZE_UNKNOWN = 'SEGMENT.SIZE_UNKNOWN',
    /**
     * @value Active
     */
    STATUS_LIVE = 'SEGMENT.STATUS_LIVE',
    /**
     * @value Only a global administrator can create a segment platform-wide.
     */
    TOOLTIP_PLATFORM_SEGMENT_BUTTON = 'SEGMENT_ADMIN.TOOLTIP_PLATFORM_SEGMENT_BUTTON',
    /**
     * @value Update the %CONFLICT_TYPE% of the segment before saving it.
     */
    UPDATE_SEGMENT_BEFORE_SAVING = 'SEGMENT.UPDATE_SEGMENT_BEFORE_SAVING',
    /**
     * @value Usage
     */
    USAGE = 'SEGMENT_ADMIN.USAGE',
    /**
     * @value Usable in multiple features
     */
    USAGE_MULTIPLE = 'SEGMENT_ADMIN.USAGE_MULTIPLE',
    /**
     * @value Used in content visibility, Play, analytics, navigation, spaces, and more
     */
    USAGE_MULTIPLE_HELPER = 'SEGMENT_ADMIN.USAGE_MULTIPLE_HELPER',
    /**
     * @value This choice cannot be changed after the segment is created.
     */
    WARNING_CHOICE_GOVERNANCE = 'SEGMENT_ADMIN.WARNING_CHOICE_GOVERNANCE',
}
